import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth';
import { TransactionDashboardComponent } from './components/transactions/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'transactionHistory',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: TransactionDashboardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BridgepayRoutingModule {}
